module.exports = __webpack_public_path__ + "static/media/investment.8621c54e.png";